import cx from "classnames";
import { Button, Modal, TranslatedString, Image } from "components";
import React, { useEffect } from "react";
import "./styles.scss";
import { CalendlyModalProps } from "./types";
import { useCalendlyEventListener, InlineWidget } from "react-calendly";
import CrossIcon from "assets/icons/cross.svg";
import { toast } from "react-toastify";
import { useGeneralDetails } from "Slices";
const CalendlyModal: React.FC<CalendlyModalProps> = ({
  visible,
  onClose,
  action,
}) => {
  const generalDetails = useGeneralDetails();
  useCalendlyEventListener({
    onProfilePageViewed: () => console.log("onProfilePageViewed"),
    onDateAndTimeSelected: () => console.log("onDateAndTimeSelected"),
    onEventTypeViewed: () => console.log("onEventTypeViewed"),
    onEventScheduled: (e) => {
      setTimeout(() => {
        toast.success("Your demo call is scheduled. Please check your email");
        onClose();
      }, 5000);
    },
  });
  return visible ? (
    <div className="calendly-modal">
      <Image
        src={CrossIcon}
        className="cross-icon clicking-animation"
        onClick={onClose}
      />
      <InlineWidget
        url="https://calendly.com/tanmay-sagar/loginwithwhatsappdemo"
        // prefill={{
        //   guests: generalDetails?.initiateEmail?.to,
        // }}
        pageSettings={{
          hideEventTypeDetails: false,
          hideLandingPageDetails: false,
          primaryColor: "2cc431",
          textColor: "4d5055",
        }}
      />
    </div>
  ) : null;
};
export default CalendlyModal;
